import axios from 'axios';

const customAxios = axios.create({
  // configurer ici les options par défaut pour votre client axios personnalisé
});

// Ajouter un intercepteur pour les requêtes sortantes
customAxios.interceptors.request.use(function (config) {
  // Modifier la configuration de la requête avant qu'elle ne soit envoyée, si nécessaire
  return config;
}, function (error) {
  // Gérer les erreurs de requête, si nécessaire
  return Promise.reject(error);
});

// Ajouter un intercepteur pour les réponses entrantes
customAxios.interceptors.response.use(function (response) {
  // Traiter les réponses réussies, si nécessaire
  return response.data;
}, function (error) {
  // Traiter les erreurs de réponse, si nécessaire
  return Promise.reject(error);
});

export default customAxios;